import { Card, Row, Col, Typography, Statistic, Tag, Space } from "antd"
import {
  BarChartOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsMore from "highcharts/highcharts-more"
import HighchartsHeatmap from "highcharts/modules/heatmap"

// Initialize Highcharts modules
HighchartsMore(Highcharts)
HighchartsHeatmap(Highcharts)

const { Text } = Typography

const KpiTracker = () => {
  // KPI Data
  const kpiData = [
    {
      key: "1",
      kpi: "Task Execution Rate",
      value: "88%",
      trend: "down",
      change: "-12%",
      status: "warning",
      notes: "Blocked by legal review",
    },
    {
      key: "2",
      kpi: "Mean Time to Mitigation",
      value: "2.3 days",
      trend: "up",
      change: "+2.3 days",
      status: "success",
      notes: "Automation helping",
    },
    {
      key: "3",
      kpi: "Risk Close Rate",
      value: "84%",
      trend: "up",
      change: "+5%",
      status: "success",
      notes: "Best month this year",
    },
    {
      key: "4",
      kpi: "Strategy Launch Rate",
      value: "56%",
      trend: "down",
      change: "-8%",
      status: "error",
      notes: "Missed 2 GTM windows",
    },
  ]

    // Charts Configuration
  const kpiTrendChart = {
    chart: { type: "line", height: 300 },
    title: { text: "KPI Trends Over Time" },
    xAxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
    yAxis: { title: { text: "Percentage" } },
    series: [
      {
        name: "Task Execution Rate",
        data: [92, 89, 91, 88, 85, 88],
        color: "#ff4d4f",
      },
      {
        name: "Risk Close Rate",
        data: [78, 80, 82, 81, 83, 84],
        color: "#52c41a",
      },
    ],
  }
  
  return (
    <Card
        title={
          <Space>
            <BarChartOutlined style={{ color: "#1890ff" }} />
            <span>Ops KPI Tracker (Smart + Contextual)</span>
          </Space>
        }
        style={{ marginBottom: "24px" }}
      >
        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          {kpiData.map((kpi, index) => (
            <Col xs={12} lg={6} key={index}>
              <Card size="small">
                <Statistic
                  title={kpi.kpi}
                  value={kpi.value}
                  prefix={kpi.trend === "up" ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                  suffix={
                    <Tag color={kpi.status === "success" ? "green" : kpi.status === "warning" ? "orange" : "red"}>
                      {kpi.change}
                    </Tag>
                  }
                  valueStyle={{
                    color: kpi.status === "success" ? "#3f8600" : kpi.status === "warning" ? "#cf1322" : "#cf1322",
                  }}
                />
                <Text type="secondary" style={{ fontSize: "12px" }}>
                  {kpi.notes}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
        <HighchartsReact highcharts={Highcharts} options={kpiTrendChart} />
      </Card>
  )
}

export default KpiTracker